import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';

import { Donut } from "./donut.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    Donut
  ],
  exports: [
    Donut
  ]
})
export class DonutModule { }